var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRights = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 15,
  viewBox: "0 0 60 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 1h60M59 1 46 14",
  stroke: "currentColor",
  strokeWidth: 2
})));
export default SvgArrowRights;